import getEnv from './getEnv'

const hostname = window.location.hostname

const urls = {
  local: `http://${hostname}:3410`,
  dev: process.env.REACT_APP_DOMAIN
    ? `https://api-delivery.${process.env.REACT_APP_DOMAIN}`
    : 'https://api-delivery.bejusto.com',
  prod: 'https://api-delivery-2.getjusto.com'
}

const env = getEnv()

if (env !== 'local' && window.location.protocol !== 'https:') {
  window.location.protocol = 'https:'
}

let url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : urls[env]

if (hostname.includes('-frontend.reploy.io')) {
  url = `https://${hostname.replace('-frontend.reploy.io', '-backend.reploy.io')}`
}

export default url

export const getMessengerVehicleURL = (vehicleId) => {
  if (env === 'local') {
    return `http://localhost:4122/api/delivery/chat-with-vehicle/${vehicleId}`
  }
  return `https://messenger.service.getjusto.com/api/delivery/chat-with-vehicle/${vehicleId}`
}